import { useContextTranslation } from '@core/i18n';
import { Heading, Subheading } from '../EmailEmbedModal.styles';
import { EmailEmbedSuccessModalWrapper, GotItButton, } from './EmailEmbedSuccessModal.styles';
/**
 *
 */
export const EmailEmbedSuccessModal = ({ onClose, }) => {
    const { t } = useContextTranslation();
    return (<EmailEmbedSuccessModalWrapper>
      <Heading marginBottom={23}>{t('player:Copied Code')}</Heading>
      <Subheading marginBottom={28}>
        {t('player:The code has been copied. Paste it into your email to embed.')}
      </Subheading>
      <GotItButton onClick={onClose}>{t('player:Got It')}</GotItButton>
    </EmailEmbedSuccessModalWrapper>);
};
